var React = require('react');

function Blocker (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"m33 0 15 15v18L33 48H15L0 33V15L15 0h18zm-2.49 5.997H17.487l-3.624 3.624 24.513 24.513L42 30.51V17.487L30.51 5.997zm3.624 32.38L9.62 13.862 6 17.484v13.029l11.484 11.484h13.029l3.62-3.62z","fill":"#55FF8A"}));
}

Blocker.defaultProps = {"width":"48","height":"48","viewBox":"0 0 48 48","fill":"none"};

module.exports = Blocker;

Blocker.default = Blocker;
